<template>
  <div class="document-status-selector d-flex align-items-center i-gap-2">
    <status-button
      label="Reject"
      v-read-only-check
      data-testid="reject-button"
      :btn-status="statusButtonOptions.REJECT"
      :on-btn-click="onStatusClick"
      icon="small-file-reject"
      :active="docStatus === options.REJECTED"
      active-class="i-text-error-90"
    ></status-button>

    <status-button
      label="Accept"
      v-read-only-check
      data-testid="accept-button"
      :btn-status="statusButtonOptions.APPROVE"
      :on-btn-click="onStatusClick"
      icon="small-file-accept"
      :active="docStatus === options.ACCEPTED"
      active-class="i-text-success-90"
    ></status-button>
  </div>
</template>
<script>
import * as documentStatusOptions from '@/constants/documentStatus';
import { StatusButtonOptions } from '@/constants/statusButtonOptions';
import StatusButton from '@/V2/components/StatusButton';
import { mapActions } from 'vuex';
import { showToast } from '@inscribe/signal';

export default {
  components: {
    StatusButton,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      docStatus: null,
      options: documentStatusOptions,
      statusButtonOptions: StatusButtonOptions,
      hovering: '',
    };
  },
  mounted() {
    this.docStatus = this.document.review_status;
  },
  methods: {
    ...mapActions(['trySetDocumentStatus']),
    onStatusClick(btnStatus) {
      const origStatus = this.docStatus;
      const newStatus =
        btnStatus === this.statusButtonOptions.APPROVE
          ? this.options.ACCEPTED
          : this.options.REJECTED;
      this.docStatus = newStatus;
      this.trySetDocumentStatus({
        document: this.document,
        data: { review_status: newStatus },
      }).then(
        (newDoc) => {
          this.docStatus = newDoc.review_status;
        },
        () => {
          this.docStatus = origStatus;
          showToast({
            text: 'An error occurrred while trying to change the document status. Please try again later.',
            isError: true,
          });
        },
      );
    },
  },
};
</script>
